export default "__VITE_ASSET__7ea66806__ 300w, __VITE_ASSET__8dc80cd8__ 600w, __VITE_ASSET__9a26c031__ 960w, __VITE_ASSET__90f361d0__ 1280w";